import React from 'react';

export function StepBasicInfoLabel() {
  return (
    <>
      Nová provozovna - <b>Údaje o provozovně</b>
    </>
  );
}
